import {  useNavigate } from 'react-router-dom'
import { ROUTES } from '@/config/types'
import { Banner, CardItem, CTA, ProcessItem } from '@/components'
import { Fade, Zoom,  JackInTheBox, Slide } from "react-awesome-reveal";
import animationMobileDevelopment from '../assets/animations/MobileDevelopment.json'
import astronaut from '../assets/animations/astronaut.json'
import WebDevelopment from '../assets/animations/MobileBrowser.json'
import cart from '../assets/animations/Cart.json'
import { TypeAnimation } from 'react-type-animation'
import { windowWidth } from '@/services/services'
import { RootState, store } from '@/store/store'
import { setNavigation } from '@/store/slices/appSlice'
import { useSelector } from 'react-redux'
import { getStorageImagePath, getTypeAnimationSequence } from '@/utils/utils'
import { SeoTags } from '@/components/SeoTags'


const getLottieForService = (slug) => {
    switch (slug) {
        case 'web-solutions':
            return WebDevelopment;
        case "mobile-app-solutions":
            return animationMobileDevelopment;
        case "ecommerce-solutions":
            return cart;
        default:
            return astronaut
    }
}
export const Home = () => {
    const appConfig = useSelector((state: RootState) => state.app.config);
    const page = appConfig?.home?.page
    const services = appConfig?.services
    const process = appConfig?.home?.process
    if (!page) return


    const showGridFour = services.length == 4
    
    return (
        <>
            <SeoTags
                page={page}
                seo_settings={store.getState().app.config.seo_settings}
            />

            <JackInTheBox triggerOnce={true} delay={1000}>
                <Banner
                    children={<div className="d-flex mt-4">
                        <Fade triggerOnce={true} delay={2000}>
                            <a className=" theme-btn btn-outline white mr-3" href="#services">
                                <span>Services</span>
                            </a>
                            <div className=" theme-btn btn-filled pointer " onClick={() => {
                                store.dispatch(setNavigation(ROUTES.CONTACT))
                            }}>
                                <span>Free Consultation</span>
                            </div>
                        </Fade>
                    </div>}
                    title={page?.banner_title}
                    image={getStorageImagePath(JSON.parse(page?.banner_image ?? {}))}
                    description={page?.banner_description}
                />
            </JackInTheBox>

            <div className="container py-100 our-services" id="services">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <Slide delay={200} triggerOnce={true} > <h1 className='text-white  stroke-animation' dangerouslySetInnerHTML={{ __html: page?.services_title }}></h1></Slide>
                        <Slide delay={400} triggerOnce={true} direction='left'>
                            <p className='text-white fs-18 mt-3 pb-3'>
                                {page.services_subtitle}
                            </p>
                        </Slide>

                    </div>

                    <div className={`col-lg-${showGridFour ? '10' : '12'}`}>
                        <div className="row">
                            {services?.map((service, index) => {
                                return <div className={`${showGridFour ? "col-lg-6" : "col-lg-4 col-md-6"} pt-3 pb-2`}>
                                    <CardItem
                                        delay={windowWidth <= 1 || index == 0 ? 1000 : (1000 + index * 200)}
                                        onClick={() => {
                                            store.dispatch(setNavigation(`/services/${service.slug}`))
                                        }}
                                        lottie={getLottieForService(service?.key)}
                                        title={service?.card_title}
                                        text={service?.card_description}
                                    />
                                </div>
                            })}
                        </div>
                    </div>

                    {/* <div className="col-lg-4 col-md-6 pt-3 pb-2">
                        <CardItem
                            delay={windowWidth <= 1 ? 1000 : 1800}
                            lottie={rates}
                            onClick={() => {
                                store.dispatch(setNavigation(ROUTES.USER_EXPERIENCE_DESIGN))
                            }}
                            title={"UX Solutions"}
                            text={"Support your customer journey through the design of a seamless user experience."}
                        />
                    </div> */}
                </div>
            </div>

            <Zoom triggerOnce={true} delay={500}>
                <div className="bg-primary py-100 text-center px-3  hover-khosher">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <h2 style={{ opacity: 0, }}>{page?.cta_loop_text}</h2>
                            <div className="position-absolute" style={{ top: 0 }}>
                                <Fade delay={800} >
                                    <TypeAnimation
                                        sequence={[
                                            page?.cta_loop_text,
                                            1000,
                                            ''
                                        ]}
                                        omitDeletionAnimation={true}
                                        wrapper="h2"
                                        className='text-white'
                                        speed={50}
                                        repeat={Infinity}
                                    />
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
            </Zoom>
            <div className="container py-100 our-services" id="services">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <Slide delay={200} direction='left'>
                            <h1 className='text-white stroke-animation' dangerouslySetInnerHTML={{ __html: page.process_title }}></h1>
                        </Slide>
                        <Slide delay={400} direction='left'>
                            <p className='text-white fs-18 mt-3 pb-3'>
                                {page.process_subtitle}
                            </p>
                        </Slide>
                    </div>
                    {process?.map((process, index) => {
                        return <div className="col-xl-4 px-3 px-md-1 col-md-6 col-12 py-0 py-3">
                            <ProcessItem
                                title={process?.title}
                                content={process?.content}
                                count={`Step 0${index + 1}`}
                                delay={windowWidth <= 1 || index == 0 ? 1000 : (1000 + index * 200)}
                                pos={(index == 0 || index == 2) ? "bottom" : "top"}
                            />
                        </div>
                    })}

                </div>
            </div>
            <CTA
                image={getStorageImagePath(JSON.parse(page?.cta_image ?? {}))}
                title={page?.cta_title}
                description={page?.cta_description} />


            <div className="bg-primary py-100 text-center px-3 hover-khosher">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <h2 className='text-white mb-3'>{page?.why_darperso_title} </h2>
                        <div className="position-relative">
                            <h2 style={{ opacity: 0 }}> Anticipate beyond what is guaranteed.</h2>
                            <div className="position-absolute center w-100" style={{ top: 0 }}>
                                <TypeAnimation
                                    sequence={getTypeAnimationSequence(
        page?.why_darperso_items)}
                                    omitDeletionAnimation={true}
                                    wrapper="h3"
                                    className='text-white '
                                    speed={25}
                                    repeat={Infinity}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
